export default () => {
  return {
    editorIsImporting: true
  };
};
